import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><g fillRule="evenodd"><path fillRule="nonzero" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10 10-4.477 10-10zM3 12a9 9 0 1118 0 9 9 0 01-18 0z" /><path d="M12.727 12L16 8.727 15.273 8 12 11.273 8.727 8 8 8.727 11.273 12 8 15.273l.727.727L12 12.727 15.273 16l.727-.727L12.727 12z" /></g></svg>);